import { Asset, DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import Question from './question/Question'
import './Step.scss'
import QuestionStepHeader from './QuestionStepHeader'

interface StepProps {
  step: DenormalizedCustomizableQuestion
  questionStyle: {
    color: string
    fontSize: string
    fontFamily?: string
  }
  descriptionStyle: {
    color: string
    fontSize: string
    fontFamily?: string
  }
  headerStyle: {
    borderBottomColor: string
    borderBottomWidth: string
    paddingBottom: string
  }
  selectAnswer: (answerId: string) => void
  selectAnswers: (answerIds: string[]) => void
  createLogoAnswer: (questionId: string, logo: Asset) => Promise<void>
  createAssetAnswer: (questionId: string, value: Asset) => void
  createColorAnswer: (questionId: string, color: string) => void
  updateColorAnswer: (questionId: string, answerId: string, color: string) => void
  removeAnswer: (answerId: string) => void
  createTextAnswer: (questionId: string, text: string, productViewText?: string) => void
  updateTextAnswer: (questionId: string, answerId: string, text: string, productViewText?: string) => void
}

const Step = ({ step, questionStyle, descriptionStyle, headerStyle, ...props }: StepProps) => {
  return (
    <div className="step" id={`step-${step.id}`} data-testid="step">
      <QuestionStepHeader
        question={step}
        questionStyle={questionStyle}
        headerStyle={headerStyle}
        descriptionStyle={descriptionStyle}
      />
      <Question question={step} {...props} />
    </div>
  )
}

export default Step
